export default __webpack_public_path__ + "static/media/loader-icon.c6b3d3bf.svg";